import { ProductDoc, ProductSupplierDoc, PurchaseBundleType } from '@gooduncles/gu-app-schema';
import { Col, Form, Input, InputNumber, Row, Select } from 'antd';
import { FC } from 'react';
import { purchaseBundleToKr } from 'src/constants';

import { inventoryPurchaseConfigTooltipMap } from 'src/utils/product-inventory-util';

interface InventoryPurchaseConfigProps {
  product: ProductDoc;
  productSuppliers?: ProductSupplierDoc[];
  isLoadingProductSuppliers?: boolean;
  initialValues?: {
    supplierId?: string;
    purchaseProductName?: string;
    purchaseBundle?: PurchaseBundleType;
    purchaseMaxBundle?: number | null;
    purchaseMultiplyUnit?: number;
    purchaseUnit?: string;
  };
}

const InventoryPurchaseConfig: FC<InventoryPurchaseConfigProps> = ({
  product,
  productSuppliers,
  isLoadingProductSuppliers,
  initialValues,
}) => {
  return (
    <>
      <h3 className='sectionTitle'>발주 설정</h3>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name='supplierId'
            label='거래처'
            rules={[{ required: true, message: '거래처를 선택해주세요' }]}
            initialValue={initialValues?.supplierId}>
            <Select
              options={productSuppliers?.map((item) => ({
                label: item.name,
                value: item._id,
              }))}
              loading={isLoadingProductSuppliers}
              placeholder='거래처 선택'
              showSearch
              filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='purchaseProductName'
            label='발주 품명'
            initialValue={initialValues?.purchaseProductName || product.fullName}
            tooltip={{
              title: inventoryPurchaseConfigTooltipMap.purchaseProductName,
              overlayStyle: { whiteSpace: 'pre-line' },
            }}>
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name='purchaseBundle'
            label='발주 분할 단위'
            tooltip={{
              title: inventoryPurchaseConfigTooltipMap.purchaseBundle,
              overlayStyle: { whiteSpace: 'pre-line' },
            }}
            rules={[{ required: true, message: '분할 단위를 선택해주세요' }]}
            initialValue={initialValues?.purchaseBundle || PurchaseBundleType.ALL}>
            <Select
              options={Object.values(PurchaseBundleType).map((type) => ({
                label: purchaseBundleToKr[type as keyof typeof purchaseBundleToKr],
                value: type,
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='purchaseMaxBundle'
            label='발주 가능 최대 묶음(0은 없음으로 처리)'
            tooltip={{
              title: inventoryPurchaseConfigTooltipMap.purchaseMaxBundle,
              overlayStyle: { whiteSpace: 'pre-line' },
            }}
            initialValue={initialValues?.purchaseMaxBundle}>
            <InputNumber style={{ width: '100%' }} min={0} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            name='purchaseMultiplyUnit'
            label='발주 단위 변환 값'
            initialValue={initialValues?.purchaseMultiplyUnit || 1}
            rules={[{ required: true, message: '발주 단위 변환 값을 입력해주세요' }]}
            tooltip={{
              title: inventoryPurchaseConfigTooltipMap.purchaseMultiplyUnit,
              overlayStyle: { whiteSpace: 'pre-line' },
            }}>
            <InputNumber style={{ width: '100%' }} min={1} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name='purchaseUnit'
            label='발주 단위'
            initialValue={initialValues?.purchaseUnit || '개'}
            tooltip={{
              title: inventoryPurchaseConfigTooltipMap.purchaseUnit,
              overlayStyle: { whiteSpace: 'pre-line' },
            }}>
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default InventoryPurchaseConfig;
